<template>
  <div class="my-plan-share-date">
    <div class="card"
         id="share-content-container"
         v-if="!showSaveHint"
    >
      <div class="header-block">
        <ym-img class="avatar"
                :src="user.avatar"
                :alt="user.name"
                v-if="user"
        />
        <div class="info">
          <span class="user-name"
                v-if="user"
          >
            {{ user.name }}
          </span>
          <span class="plan-desc">正在参加「{{ plan.title }}」</span>
        </div>
      </div>
      <div class="success-info">
        <ym-img class="img"
                :src="require('@/assets/img/plan/success.png')"
                alt=""
        />
        <span class="tip">已完成今天的学习计划</span>
      </div>
      <div class="count-block">
        <div class="item">
          <span class="desc">连续学习</span>
          <span class="count">
            <span class="num">{{ plan.statistics.continueCount }}</span>天
          </span>
        </div>
        <div class="item">
          <span class="desc">已学音频</span>
          <span class="count">
            <span class="num">{{ plan.statistics.finishCount }}</span>讲
          </span>
        </div>
        <div class="item">
          <span class="desc">总时长</span>
          <span class="count">
              <span class="num">{{ plan.statistics.minuteCount }}</span>分钟
            </span>
        </div>
      </div>
      <div class="footer">
        <ym-img class="qr-code"
                :src="qrCode.src"
                alt="少年商学院"
        />
        <div class="info">
          <h4>{{ plan.title }}</h4>
          <span class="desc">帮助孩子提升综合竞争力</span>
        </div>
      </div>
    </div>


    <div class="result-container">
      <div id="result-container"></div>
      <div class="save-hint"
           v-show="showSaveHint"
      >长按保存图片
      </div>
    </div>
  </div>
</template>

<script>
  import { getFinishPlanTaskShare } from '@/services/plan';
  import { htmlToCanvas, canvasToImage } from '@/utils/canvas';

  export default {
    name: 'MyPlanShareDate',
    metaInfo: {
      title: '分享',
    },
    data() {
      return {
        plan: {
          title: '',
          statistics: {
            continueCount: 0,
            finishCount: 0,
            minuteCount: 0,
          },
        },
        user: null,
        qrCode: {
          src: '',
        },
        render: {
          pageTitle: '分享',
        },
        showSaveHint: false,
      };
    },
    methods: {
      async fetchData(id) {
        const data = await getFinishPlanTaskShare(id);
        this.plan = data.plan;
        this.user = data.user;
        this.qrCode = data.qrCode;
        this.render = data.render;
        this.$nextTick(() => {
          this.generateImage();
        });
      },
      async generateImage() {
        const $certificate = document.getElementById('share-content-container');
        const $resultContainer = document.getElementById('result-container');
        const canvas = await htmlToCanvas($certificate);
        const img = canvasToImage(canvas);
        $resultContainer.appendChild(img);
        this.showSaveHint = true;
      },
    },
    created() {
      const { id } = this.$route.params;
      this.fetchData(id);
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.fetchData(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .my-plan-share-date {
    padding: @size-medium 0;
    background: @background-color-lighter;
  }

  .result-container {
    /deep/ img {
      display: block;
      width: 750px;
    }
  }

  .card {
    width: 750px;
    height: 986px;
    padding: @size-medium * 2 0;
    box-sizing: border-box;
    background-image: url("~@/assets/img/plan/share_bg.png");
    background-size: contain;
  }

  .header-block {
    padding-left: 90px;
    display: flex;
    align-items: center;
  }

  .avatar {
    margin-right: @size-small;
    flex-shrink: 0;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    border: @border-base;
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .user-name {
      margin-bottom: @size-small;
      font-size: @font-size-medium;
      color: @color-text-base;
      line-height: 1;
    }
    .plan-desc {
      font-size: @font-size-small;
      line-height: 1;
      color: @color-text-lighter;
    }
  }

  .success-info {
    margin: @size-extra-large auto @size-large;
    display: flex;
    flex-direction: column;
    align-items: center;
    .img {
      margin-bottom: @size-medium;
      display: block;
      width: 300px;
      height: 242px;
    }
    .tip {
      font-size: @font-size-large;
      font-weight: @font-weight-bold;
      color: @color-text-base;
      line-height: 1;
    }
  }

  .count-block {
    margin: 0 auto @size-large;
    width: 600px;
    display: flex;
    .item {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: @color-text-light;
      &:not(:last-child) {
        border-right: @border-base;
      }
    }
    .desc {
      margin-bottom: @size-small;
      font-size: @font-size-small;
      line-height: 1;
    }
    .num {
      margin-right: @size-extra-small;
      // font-weight: @font-weight-bold;
      font-size: @font-size-largest;
      color: @color-text-base;
      line-height: 1;
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qr-code {
    margin-right: @size-small;
    display: block;
    width: 100px;
    height: 100px;
  }

  .info {
    h4 {
      margin: 0 0 @size-small 0;
      padding: 0;
      font-size: @font-size-base;
      color: @color-text-base;
      font-weight: @font-weight-bold;
      line-height: 1;
    }
    .desc {
      color: @color-text-light;
      font-size: @font-size-small;
      line-height: 1;
    }
  }

  .save-hint {
    text-align: center;
    font-size: @font-size-medium;
    color: @color-text-base;
  }

</style>
